// extracted by mini-css-extract-plugin
export var numpadContainer = "_ru-1";
export var phoneButton = "_ru-0";